import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.lpsysadmin.collab.notification');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-lpsysadmin-collab-notification',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/portal.lpsysadmin.collab.notification/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PortalLpsysadminCollabNotificationComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public rows: any[] = [];
    public total: number = 0;
    public unreadCount: number = 0;
    public page: number = 1;
    public dump: number = 30;

    public filterUnread: boolean = false;
    public filterType: string = '';
    public loaded: boolean = false;

    public showSettings: boolean = false;
    public settings: any = {};

    public types = [
        { key: '', title: '전체', icon: 'inbox' },
        { key: 'task', title: '업무', icon: 'check' },
        { key: 'chat', title: '메신저', icon: 'chat' },
        { key: 'mention', title: '멘션', icon: 'at' },
        { key: 'meeting', title: '회의', icon: 'video' },
        { key: 'calendar', title: '일정', icon: 'calendar' },
        { key: 'post', title: '게시판', icon: 'doc' },
        { key: 'file', title: '파일', icon: 'file' },
        { key: 'workspace', title: '워크스페이스', icon: 'briefcase' },
        { key: 'system', title: '시스템', icon: 'cog' },
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.search();
    }

    public async search(reset: boolean = true) {
        if (reset) this.page = 1;
        const res = await wiz.call("search", {
            page: this.page, dump: this.dump,
            unread: this.filterUnread ? '1' : '',
            type: this.filterType,
        });
        if (res.code === 200) {
            this.rows = res.data.rows || [];
            this.total = res.data.total || 0;
            this.unreadCount = res.data.unread_count || 0;
        }
        this.loaded = true;
        await this.service.render();
    }

    public async openItem(item: any) {
        if (!item.read_at) {
            await wiz.call("mark_read", { id: item.id });
            item.read_at = new Date().toISOString();
            this.unreadCount = Math.max(0, this.unreadCount - 1);
        }
        if (item.link) {
            this.service.href(item.link);
        } else {
            await this.service.render();
        }
    }

    public async markAllRead() {
        const res = await wiz.call("mark_all_read", { type: this.filterType });
        if (res.code === 200) {
            this.service.alert.success(`${res.data.count}건을 읽음 처리했습니다.`);
            await this.search();
        } else {
            this.service.alert.error(res.data?.message || '실패');
        }
    }

    public async remove(item: any, ev: Event) {
        ev.stopPropagation();
        const res = await wiz.call("remove", { id: item.id });
        if (res.code === 200) {
            this.rows = this.rows.filter(r => r.id !== item.id);
            this.total = Math.max(0, this.total - 1);
            await this.service.render();
        }
    }

    public async openSettings() {
        const res = await wiz.call("settings", {});
        if (res.code === 200) {
            this.settings = res.data.settings || {};
            // ensure default keys
            for (const t of this.types) {
                if (!t.key) continue;
                if (!this.settings[t.key]) {
                    this.settings[t.key] = { in_app: true, email: false, push: false };
                }
            }
            this.showSettings = true;
            await this.service.render();
        }
    }

    public async saveSetting(typeKey: string) {
        const s = this.settings[typeKey];
        const res = await wiz.call("update_setting", {
            type: typeKey,
            in_app: s.in_app ? '1' : '',
            email: s.email ? '1' : '',
            push: s.push ? '1' : '',
            dnd_from: s.dnd_from || '',
            dnd_to: s.dnd_to || '',
        });
        if (res.code !== 200) {
            this.service.alert.error('저장 실패');
        }
        await this.service.render();
    }

    public iconClass(t: string): string {
        const map: any = {
            task: 'fa-circle-check', chat: 'fa-message',
            mention: 'fa-at', meeting: 'fa-video',
            calendar: 'fa-calendar-days', post: 'fa-newspaper',
            file: 'fa-folder', workspace: 'fa-briefcase',
            system: 'fa-gear',
        };
        return map[t] || 'fa-bell';
    }

    public iconColor(t: string): string {
        const map: any = {
            task: 'text-emerald-600 bg-emerald-50',
            chat: 'text-blue-600 bg-blue-50',
            mention: 'text-rose-600 bg-rose-50',
            meeting: 'text-violet-600 bg-violet-50',
            calendar: 'text-amber-600 bg-amber-50',
            post: 'text-zinc-600 bg-zinc-100',
            file: 'text-cyan-600 bg-cyan-50',
            workspace: 'text-indigo-600 bg-indigo-50',
            system: 'text-zinc-500 bg-zinc-100',
        };
        return map[t] || 'text-zinc-500 bg-zinc-100';
    }

    public timeAgo(s: string): string {
        if (!s) return '';
        const d = new Date(s.replace(' ', 'T'));
        const diff = (Date.now() - d.getTime()) / 1000;
        if (diff < 60) return '방금';
        if (diff < 3600) return Math.floor(diff / 60) + '분 전';
        if (diff < 86400) return Math.floor(diff / 3600) + '시간 전';
        if (diff < 604800) return Math.floor(diff / 86400) + '일 전';
        return s.substring(0, 10);
    }
}

export default PortalLpsysadminCollabNotificationComponent;